import { useEffect, useState } from 'react';
import { useQuery } from '@/hooks/useQuery';
import { api } from '@/services/api';
import type { WorldIndicesResponse } from '@/types';

const REFRESH_MS = 15 * 60 * 1000;

export function useWorldIndices(): { data: WorldIndicesResponse | null; loading: boolean; error: string | null } {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const id = window.setInterval(() => setTick((n) => n + 1), REFRESH_MS);
    return () => window.clearInterval(id);
  }, []);

  return useQuery<WorldIndicesResponse>(() => api.worldIndices(), [tick]);
}